
import React from 'react';
import { XCircle } from 'lucide-react';
import { Link } from 'react-router-dom';

const ErrorState: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center max-w-md px-4">
        <XCircle size={40} className="mx-auto mb-4 text-red-500" />
        <h2 className="text-xl font-semibold mb-2">Análise não encontrada</h2>
        <p className="text-gray-500 mb-6">Não foi possível encontrar os dados da análise. Por favor, realize uma nova análise.</p>
        <Link to="/" className="btn-primary">Voltar para o início</Link>
      </div>
    </div>
  );
};

export default ErrorState;
